export default __webpack_public_path__ + "static/media/trust.6b8df5cc.png";